import { graphql } from "gatsby";
import { Script } from "gatsby-script";
import React from "react";

interface Props {
  pushnamiId: string;
}

export default function Pushnami({ pushnamiId }: Props) {
  return (
    <Script
      strategy="idle"
      src={`https://api.pushnami.com/scripts/v1/push/${pushnamiId}`}
    ></Script>
  );
}

export const fragments = graphql`
  fragment Pushnami on Site {
    siteMetadata {
      pushnamiId
    }
  }
`;
